<!-- 图片弹窗(如何获取) -->
<template>
  <el-dialog
    title="如何获取"
    :visible="dialogVisible"
    :close-on-click-modal="false"
    :popper-append-to-body="true"
    class="img-dialog"
    width="920px"
    @close="dialogHandle"
  >
    <div class="dialog-body">
      <img :src="src" alt="#" style="width: 790px" />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ImgDialog',
  components: {},
  props: {
    src: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  // 生命周期 - 创建完成（访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（访问DOM元素）
  mounted() {},
  methods: {
    dialogHandle() {
      this.$emit('update:dialogVisible', false);
    },
  },
};
</script>
<style lang="scss" scoped>
.img-dialog {
  .dialog-body {
    text-align: center;
    img {
      padding: 25px;
      background: rgba(245, 247, 250, 0.45);
      border-radius: 8px;
      border-radius: 8px;
    }
  }
}
</style>
